import api from "../api-backend";

class TitulacioService {

    getTitulacions = async (page, size, query, sort) => {
        const response = await api.get(`/engine/titulacions?query=${query}&rows=${size}&start=${page}&sort=${sort}`)
        return {
            'titulacions': response.data.response.docs,
            'facetes': response.data.facet_counts.facet_fields,
            'total': response.data.response.numFound
        }
    }

    getTitulacio = async (id) => {
        const response = await api.get(`/engine/${id}`)
        return {
            'titulacio': response.data.response.docs[0],
        }
    }
}

export default new TitulacioService()
